import React, { useEffect } from 'react';
import LoginRegisterSchema from '../../common/layout/LoginRegisterSchema';
import FormRegister from './pieces/FormRegister';
import FormRegisterStep2 from './pieces/FormRegisterStep2';
import Info from './pieces/Info';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getConfig } from '../../../store/actions/configActions';

const Register = () => {
  const { registration, isAuthenticated } = useSelector(state => state.auth);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getConfig());
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      const {
        location: { search },
      } = history;
      if (search.indexOf('?voltar-para=') !== -1) {
        const urlLocation = search.substr(search.indexOf('?voltar-para=') + 13, search.length);
        history.push(urlLocation);
      } else {
        history.push('/dashboard');
      }
    }
  }, [isAuthenticated, history]);

  return (
    <LoginRegisterSchema
      info={<Info />}
      form={
        registration.step === '1' ? <FormRegister /> : <FormRegisterStep2 info={registration} />
      }
    />
  );
};

export default Register;
